import { EmailEntryPoint } from "@simplyk/common";

export type EmailChoiceSource =
  | "contacts"
  | "list"
  | "members"
  | "companies"
  | "households"
  | "payments"
  | "guest_list"
  | "comm_page"
  | "email_guests"
  | "extra_thank_you"
  | "copy_email";

export const EMAIL_CHOICE_SOURCE_BY_ENTRY_POINT = {
  [EmailEntryPoint.ContactsPageBulkEmail]: "contacts",
  [EmailEntryPoint.ContactDrawerHeaderButton]: "contacts",
  [EmailEntryPoint.ContactsPageRowEmail]: "contacts",
  [EmailEntryPoint.ListPageBulkEmail]: "list",
  [EmailEntryPoint.ListsPageCardMenuEmail]: "list",
  [EmailEntryPoint.MembersPageBulkEmail]: "members",
  [EmailEntryPoint.MembersPageRowEmail]: "members",
  [EmailEntryPoint.CompaniesPageBulkEmail]: "companies",
  [EmailEntryPoint.CompanyDrawerHeaderButton]: "companies",
  [EmailEntryPoint.HouseholdDrawerHeaderButton]: "households",
  [EmailEntryPoint.CampaignHubPaymentsBulkEmail]: "payments",
  [EmailEntryPoint.PaymentsPageBulkEmail]: "payments",
  [EmailEntryPoint.CampaignHubGuestListBulkEmail]: "guest_list",
  [EmailEntryPoint.EmailsPageNewEmailButton]: "comm_page",
  [EmailEntryPoint.EmailDetailsNewEmailButton]: "comm_page",
  [EmailEntryPoint.EmailsPageEmptyState]: "comm_page",
  [EmailEntryPoint.CampaignHubCommunicationTab]: "comm_page",
  [EmailEntryPoint.CampaignHubEmailGuestsButton]: "email_guests",
  [EmailEntryPoint.CampaignHubEmailDonorsButton]: "email_guests",
  [EmailEntryPoint.CampaignHubEmailMembersButton]: "email_guests",
  [EmailEntryPoint.CampaignHubEmailBiddersButton]: "email_guests",
  [EmailEntryPoint.CampaignHubEmailBuyersButton]: "email_guests",
  [EmailEntryPoint.PaymentDrawerThankYouButton]: "extra_thank_you",
  [EmailEntryPoint.CampaignHubPaymentsThankYouCell]: "extra_thank_you",
  [EmailEntryPoint.PaymentsPageThankYouCell]: "extra_thank_you",
  [EmailEntryPoint.CopyEmailPopoverButton]: "copy_email",
} as const satisfies Partial<Record<EmailEntryPoint, EmailChoiceSource>>;

export type EmailTypeChoiceEntryPoint = keyof typeof EMAIL_CHOICE_SOURCE_BY_ENTRY_POINT;
